import { css } from '@emotion/css';
import { reconcile } from 'solid-js/store';
import { ImageUpload } from 'Shared/forms/ImageUpload';
import { StoreProvider, useStore } from 'Shared/StoreProvider';
import type {ImageLayout} from 'Shared/model/Components';
import { LabelOnLeftWrap } from 'Shared/forms/Wrap';
import { Checkbox, SingleSelect } from 'Shared/forms/Inputs';
import { Show } from 'solid-js';
import * as ImageSizes from 'Shared/model/ImageSizes';
import { verticalStyle } from 'Shared/backend/Theme';
import { theme } from 'Shared/ThemeProvider';
import { RatioCrop, VerticalConstraint } from 'Shared/backend/widgets/VerticalConstraint';
import { useLayout } from 'Shared/backend/LayoutProvider';

/*
	Note that the crop (and height) options here wil mostly be used for standalone images
    and the backgrounds of overlays.

	The height is required for overlay backgrounds.
*/

//TODO add option to downsize/compress image?

//TODO support focal point or text-based 'Custom' position

//TODO ALLOW BACKGROUND COLOUR TO BE SET here and in sliders & grids? Maybe images too esp to dimBackground, black, white, transparent

export function ImageBlock(P:ImageLayout)
{
	const imageUploadStyle = css({
		img: {
			maxWidth: 450,
			maxHeight: 300
		}
	});

	const displayHeadingStyle = css(theme().heading,{
		margin: '0 0'
	});


	const sw = useStore();
	const lo = useLayout();
	const setImage = value => sw.setStore(...sw.location,'image',reconcile(value));

	const previewRatio = () => ImageSizes[P.crop]?.ratio ?? 1;

	return (
		<div class={verticalStyle()}>
			<StoreProvider {...sw} location={[...sw.location,'upload']}>
				<RatioCrop {...P.upload} ratioLabel='Crop on upload' ratioRequired={false} />
			</StoreProvider>

			<div class={imageUploadStyle}>
				<StoreProvider {...sw} location={[...sw.location,'image']}>
					<ImageUpload 
						small={true}
						image={P.image} 
						setImage={setImage} 
						folder={sw.imageFolder}
						dimensions={P.upload.ratio ?? 'compAny'}
						previewRatio={previewRatio()}
					/>
				</StoreProvider>
			</div>

			<Show when={lo.layout()}>
				<div class={verticalStyle()}>
					<h4 class={displayHeadingStyle}>Display settings</h4>

					<StoreProvider {...sw} location={[...sw.location,'display']}>
						<VerticalConstraint {...P.display} label='Height' options={['parent','child','ratio','height']} />

						<LabelOnLeftWrap label='Fit'>
							<SingleSelect field='fit' required={true} options={{
								cover: 'Cover',
								contain: 'Contain',
								'scale-down': 'Scale down',
								fill: 'Fill',
								none: 'None'
							}} />
						</LabelOnLeftWrap>

						<Show when={P.display.fit != 'stretch'}>
							<LabelOnLeftWrap label='Position'>
								<SingleSelect field='position' required={true} options={{
									center: 'Center',
									top: 'Top',
									bottom: 'Bottom',
									left: 'Left',
									right: 'Right',
	//								custom: 'Custom',
								}} />
							</LabelOnLeftWrap>
						</Show>

						<LabelOnLeftWrap 
							label='Size and quality' 
							notes={`
								Use "medium" for most images, and "large" wide items such as as banners. 
								"original" can be used to override the defaults, but in this case 
								you are responsible for ensuring the image is adequately compressed.
								Large files slow down page loading.
							`}
						>
							<SingleSelect field='size' required={true} options={{
								medium: 'Medium',
								large: 'Large',
								full: 'Original'
							}} />
						</LabelOnLeftWrap>
					</StoreProvider>
				</div>
			</Show>
		</div>
	);
}

